// extracted by mini-css-extract-plugin
export default {"paragraphWrapper":"style_paragraphWrapper__VJScH","paragraph":"style_paragraph__me-lA","word":"style_word__V+QUl"};